import React, { useState, memo } from 'react';
import { BookOpen, Users, Award } from 'lucide-react';
const TipsPage = () => {
  const [activeTab, setActiveTab] = useState('theory');
  return <div className="bg-white" data-id="element-1926">
      <div className="container mx-auto px-4 py-12" data-id="element-1927">
        <h1 className="text-3xl md:text-4xl font-bold mb-6" data-id="element-1928">Driving Tips</h1>
        <p className="text-gray-700 mb-8" data-id="element-1929">
          Whether you're preparing for your theory test, just passed your
          practical test, or have been driving for years, we've compiled some
          useful tips to help you become a safer and more confident driver.
        </p>
        {/* Tabs */}
        <div className="flex flex-wrap border-b border-gray-200 mb-8" data-id="element-1930">
          <button className={`mr-4 py-2 px-4 font-medium rounded-t-lg ${activeTab === 'theory' ? 'bg-burgundy-600 text-white' : 'text-gray-600 hover:text-burgundy-600'}`} onClick={() => setActiveTab('theory')} data-id="element-1931">
            <div className="flex items-center" data-id="element-1932">
              <BookOpen size={18} className="mr-2" data-id="element-1933" />
              Theory Test Tips
            </div>
          </button>
          <button className={`mr-4 py-2 px-4 font-medium rounded-t-lg ${activeTab === 'new' ? 'bg-burgundy-600 text-white' : 'text-gray-600 hover:text-burgundy-600'}`} onClick={() => setActiveTab('new')} data-id="element-1934">
            <div className="flex items-center" data-id="element-1935">
              <Users size={18} className="mr-2" data-id="element-1936" />
              New Drivers Tips
            </div>
          </button>
          <button className={`py-2 px-4 font-medium rounded-t-lg ${activeTab === 'experienced' ? 'bg-burgundy-600 text-white' : 'text-gray-600 hover:text-burgundy-600'}`} onClick={() => setActiveTab('experienced')} data-id="element-1937">
            <div className="flex items-center" data-id="element-1938">
              <Award size={18} className="mr-2" data-id="element-1939" />
              Experienced Drivers Tips
            </div>
          </button>
        </div>
        {/* Content */}
        <div className="mb-12" data-id="element-1940">
          {activeTab === 'theory' && <div data-id="element-1941">
              <h2 className="text-2xl font-bold mb-4" data-id="element-1942">Theory Test Tips</h2>
              <div className="grid grid-cols-1 md:grid-cols-2 gap-8 mb-8" data-id="element-1943">
                <div className="bg-gray-50 p-6 rounded-lg" data-id="element-1944">
                  <h3 className="text-xl font-semibold mb-3" data-id="element-1945">
                    Multiple Choice Questions
                  </h3>
                  <ul className="space-y-2" data-id="element-1946">
                    <li className="flex items-start" data-id="element-1947">
                      <div className="text-burgundy-600 mr-2" data-id="element-1948">•</div>
                      <div data-id="element-1949">
                        Study the Highway Code thoroughly - it forms the basis
                        of many questions.
                      </div>
                    </li>
                    <li className="flex items-start" data-id="element-1950">
                      <div className="text-burgundy-600 mr-2" data-id="element-1951">•</div>
                      <div data-id="element-1952">
                        Use official DVSA practice materials and apps to
                        familiarise yourself with the question format.
                      </div>
                    </li>
                    <li className="flex items-start" data-id="element-1953">
                      <div className="text-burgundy-600 mr-2" data-id="element-1954">•</div>
                      <div data-id="element-1955">
                        Create a study schedule and stick to it - consistent
                        practice is key.
                      </div>
                    </li>
                    <li className="flex items-start" data-id="element-1956">
                      <div className="text-burgundy-600 mr-2" data-id="element-1957">•</div>
                      <div data-id="element-1958">
                        Focus on traffic signs and road markings, as these
                        frequently appear in the test.
                      </div>
                    </li>
                    <li className="flex items-start" data-id="element-1959">
                      <div className="text-burgundy-600 mr-2" data-id="element-1960">•</div>
                      <div data-id="element-1961">
                        Don't just memorise answers - understand the reasoning
                        behind them.
                      </div>
                    </li>
                  </ul>
                </div>
                <div className="bg-gray-50 p-6 rounded-lg" data-id="element-1962">
                  <h3 className="text-xl font-semibold mb-3" data-id="element-1963">
                    Hazard Perception
                  </h3>
                  <ul className="space-y-2" data-id="element-1964">
                    <li className="flex items-start" data-id="element-1965">
                      <div className="text-burgundy-600 mr-2" data-id="element-1966">•</div>
                      <div data-id="element-1967">
                        Practise spotting developing hazards - click when you
                        first see a potential danger.
                      </div>
                    </li>
                    <li className="flex items-start" data-id="element-1968">
                      <div className="text-burgundy-600 mr-2" data-id="element-1969">•</div>
                      <div data-id="element-1970">
                        Avoid clicking too many times in quick succession, as
                        this can be flagged as cheating.
                      </div>
                    </li>
                    <li className="flex items-start" data-id="element-1971">
                      <div className="text-burgundy-600 mr-2" data-id="element-1972">•</div>
                      <div data-id="element-1973">
                        Look for clues like pedestrians near the road, children
                        playing, or vehicles signalling.
                      </div>
                    </li>
                    <li className="flex items-start" data-id="element-1974">
                      <div className="text-burgundy-600 mr-2" data-id="element-1975">•</div>
                      <div data-id="element-1976">
                        Remember that each clip contains at least one developing
                        hazard.
                      </div>
                    </li>
                    <li className="flex items-start" data-id="element-1977">
                      <div className="text-burgundy-600 mr-2" data-id="element-1978">•</div>
                      <div data-id="element-1979">
                        Use official DVSA hazard perception practice tests to
                        get familiar with the format.
                      </div>
                    </li>
                  </ul>
                </div>
              </div>
              <div className="bg-gray-50 p-6 rounded-lg" data-id="element-1980">
                <h3 className="text-xl font-semibold mb-3" data-id="element-1981">On Test Day</h3>
                <ul className="space-y-2" data-id="element-1982">
                  <li className="flex items-start" data-id="element-1983">
                    <div className="text-burgundy-600 mr-2" data-id="element-1984">•</div>
                    <div data-id="element-1985">Get a good night's sleep before your test.</div>
                  </li>
                  <li className="flex items-start" data-id="element-1986">
                    <div className="text-burgundy-600 mr-2" data-id="element-1987">•</div>
                    <div data-id="element-1988">
                      Arrive at the test centre at least 15 minutes early with
                      your provisional licence and booking reference.
                    </div>
                  </li>
                  <li className="flex items-start" data-id="element-1989">
                    <div className="text-burgundy-600 mr-2" data-id="element-1990">•</div>
                    <div data-id="element-1991">
                      Read each question carefully and consider all options
                      before answering.
                    </div>
                  </li>
                  <li className="flex items-start" data-id="element-1992">
                    <div className="text-burgundy-600 mr-2" data-id="element-1993">•</div>
                    <div data-id="element-1994">
                      If you're unsure about a question, flag it and return to
                      it later.
                    </div>
                  </li>
                  <li className="flex items-start" data-id="element-1995">
                    <div className="text-burgundy-600 mr-2" data-id="element-1996">•</div>
                    <div data-id="element-1997">
                      Manage your time carefully - you have 57 minutes for the
                      multiple-choice section.
                    </div>
                  </li>
                </ul>
              </div>
            </div>}
          {activeTab === 'new' && <div data-id="element-1998">
              <h2 className="text-2xl font-bold mb-4" data-id="element-1999">New Drivers Tips</h2>
              <div className="grid grid-cols-1 md:grid-cols-2 gap-8 mb-8" data-id="element-2000">
                <div className="bg-gray-50 p-6 rounded-lg" data-id="element-2001">
                  <h3 className="text-xl font-semibold mb-3" data-id="element-2002">
                    Building Confidence
                  </h3>
                  <ul className="space-y-2" data-id="element-2003">
                    <li className="flex items-start" data-id="element-2004">
                      <div className="text-burgundy-600 mr-2" data-id="element-2005">•</div>
                      <div data-id="element-2006">
                        Start with short, familiar journeys to build your
                        confidence gradually.
                      </div>
                    </li>
                    <li className="flex items-start" data-id="element-2007">
                      <div className="text-burgundy-600 mr-2" data-id="element-2008">•</div>
                      <div data-id="element-2009">
                        Drive during daylight and good weather conditions
                        initially.
                      </div>
                    </li>
                    <li className="flex items-start" data-id="element-2010">
                      <div className="text-burgundy-600 mr-2" data-id="element-2011">•</div>
                      <div data-id="element-2012">
                        Consider taking a Pass Plus course to develop your
                        skills further.
                      </div>
                    </li>
                    <li className="flex items-start" data-id="element-2013">
                      <div className="text-burgundy-600 mr-2" data-id="element-2014">•</div>
                      <div data-id="element-2015">
                        Drive solo to develop your own decision-making
                        abilities.
                      </div>
                    </li>
                    <li className="flex items-start" data-id="element-2016">
                      <div className="text-burgundy-600 mr-2" data-id="element-2017">•</div>
                      <div data-id="element-2018">
                        Remember that building confidence takes time - don't
                        rush yourself.
                      </div>
                    </li>
                  </ul>
                </div>
                <div className="bg-gray-50 p-6 rounded-lg" data-id="element-2019">
                  <h3 className="text-xl font-semibold mb-3" data-id="element-2020">Safety First</h3>
                  <ul className="space-y-2" data-id="element-2021">
                    <li className="flex items-start" data-id="element-2022">
                      <div className="text-burgundy-600 mr-2" data-id="element-2023">•</div>
                      <div data-id="element-2024">
                        Always adjust your mirrors and seat before setting off.
                      </div>
                    </li>
                    <li className="flex items-start" data-id="element-2025">
                      <div className="text-burgundy-600 mr-2" data-id="element-2026">•</div>
                      <div data-id="element-2027">
                        Avoid distractions - set up your navigation and music
                        before starting your journey.
                      </div>
                    </li>
                    <li className="flex items-start" data-id="element-2028">
                      <div className="text-burgundy-600 mr-2" data-id="element-2029">•</div>
                      <div data-id="element-2030">
                        Never use your phone while driving - it's illegal and
                        dangerous.
                      </div>
                    </li>
                    <li className="flex items-start" data-id="element-2031">
                      <div className="text-burgundy-600 mr-2" data-id="element-2032">•</div>
                      <div data-id="element-2033">
                        Be aware of the New Driver Act - you'll lose your
                        licence if you get 6 points within 2 years of passing.
                      </div>
                    </li>
                    <li className="flex items-start" data-id="element-2034">
                      <div className="text-burgundy-600 mr-2" data-id="element-2035">•</div>
                      <div data-id="element-2036">
                        Leave plenty of space between you and the vehicle in
                        front.
                      </div>
                    </li>
                  </ul>
                </div>
              </div>
              <div className="bg-gray-50 p-6 rounded-lg" data-id="element-2037">
                <h3 className="text-xl font-semibold mb-3" data-id="element-2038">Practical Advice</h3>
                <ul className="space-y-2" data-id="element-2039">
                  <li className="flex items-start" data-id="element-2040">
                    <div className="text-burgundy-600 mr-2" data-id="element-2041">•</div>
                    <div data-id="element-2042">
                      Learn basic car maintenance like checking oil, water, and
                      tyre pressure.
                    </div>
                  </li>
                  <li className="flex items-start" data-id="element-2043">
                    <div className="text-burgundy-600 mr-2" data-id="element-2044">•</div>
                    <div data-id="element-2045">
                      Consider taking a motorway driving lesson with an
                      instructor, as this isn't covered in the standard test.
                    </div>
                  </li>
                  <li className="flex items-start" data-id="element-2046">
                    <div className="text-burgundy-600 mr-2" data-id="element-2047">•</div>
                    <div data-id="element-2048">
                      Plan unfamiliar journeys in advance and allow extra time.
                    </div>
                  </li>
                  <li className="flex items-start" data-id="element-2049">
                    <div className="text-burgundy-600 mr-2" data-id="element-2050">•</div>
                    <div data-id="element-2051">
                      Keep a small emergency kit in your car (torch, blanket,
                      water, etc.).
                    </div>
                  </li>
                  <li className="flex items-start" data-id="element-2052">
                    <div className="text-burgundy-600 mr-2" data-id="element-2053">•</div>
                    <div data-id="element-2054">
                      Shop around for insurance - consider black box policies
                      which can reduce premiums for safe driving.
                    </div>
                  </li>
                </ul>
              </div>
            </div>}
          {activeTab === 'experienced' && <div data-id="element-2055">
              <h2 className="text-2xl font-bold mb-4" data-id="element-2056">
                Experienced Drivers Tips
              </h2>
              <div className="grid grid-cols-1 md:grid-cols-2 gap-8 mb-8" data-id="element-2057">
                <div className="bg-gray-50 p-6 rounded-lg" data-id="element-2058">
                  <h3 className="text-xl font-semibold mb-3" data-id="element-2059">
                    Refreshing Your Skills
                  </h3>
                  <ul className="space-y-2" data-id="element-2060">
                    <li className="flex items-start" data-id="element-2061">
                      <div className="text-burgundy-600 mr-2" data-id="element-2062">•</div>
                      <div data-id="element-2063">
                        Consider a refresher lesson if you haven't driven for a
                        while.
                      </div>
                    </li>
                    <li className="flex items-start" data-id="element-2064">
                      <div className="text-burgundy-600 mr-2" data-id="element-2065">•</div>
                      <div data-id="element-2066">
                        Stay updated with changes to the Highway Code - they
                        happen more often than you might think.
                      </div>
                    </li>
                    <li className="flex items-start" data-id="element-2067">
                      <div className="text-burgundy-600 mr-2" data-id="element-2068">•</div>
                      <div data-id="element-2069">
                        Practise advanced manoeuvres like parallel parking in a
                        quiet area if you're rusty.
                      </div>
                    </li>
                    <li className="flex items-start" data-id="element-2070">
                      <div className="text-burgundy-600 mr-2" data-id="element-2071">•</div>
                      <div data-id="element-2072">
                        Consider an advanced driving course like IAM RoadSmart
                        or RoSPA.
                      </div>
                    </li>
                    <li className="flex items-start" data-id="element-2073">
                      <div className="text-burgundy-600 mr-2" data-id="element-2074">•</div>
                      <div data-id="element-2075">
                        Regularly check for bad habits that may have crept into
                        your driving style.
                      </div>
                    </li>
                  </ul>
                </div>
                <div className="bg-gray-50 p-6 rounded-lg" data-id="element-2076">
                  <h3 className="text-xl font-semibold mb-3" data-id="element-2077">
                    Defensive Driving
                  </h3>
                  <ul className="space-y-2" data-id="element-2078">
                    <li className="flex items-start" data-id="element-2079">
                      <div className="text-burgundy-600 mr-2" data-id="element-2080">•</div>
                      <div data-id="element-2081">
                        Anticipate other road users' actions - expect the
                        unexpected.
                      </div>
                    </li>
                    <li className="flex items-start" data-id="element-2082">
                      <div className="text-burgundy-600 mr-2" data-id="element-2083">•</div>
                      <div data-id="element-2084">
                        Maintain a safe following distance (at least 2 seconds,
                        more in poor conditions).
                      </div>
                    </li>
                    <li className="flex items-start" data-id="element-2085">
                      <div className="text-burgundy-600 mr-2" data-id="element-2086">•</div>
                      <div data-id="element-2087">
                        Regularly check your mirrors and be aware of your blind
                        spots.
                      </div>
                    </li>
                    <li className="flex items-start" data-id="element-2088">
                      <div className="text-burgundy-600 mr-2" data-id="element-2089">•</div>
                      <div data-id="element-2090">
                        Stay calm in challenging situations - road rage helps no
                        one.
                      </div>
                    </li>
                    <li className="flex items-start" data-id="element-2091">
                      <div className="text-burgundy-600 mr-2" data-id="element-2092">•</div>
                      <div data-id="element-2093">
                        Always have an escape route planned in case of
                        emergency.
                      </div>
                    </li>
                  </ul>
                </div>
              </div>
              <div className="bg-gray-50 p-6 rounded-lg" data-id="element-2094">
                <h3 className="text-xl font-semibold mb-3" data-id="element-2095">
                  Long-Term Driving Health
                </h3>
                <ul className="space-y-2" data-id="element-2096">
                  <li className="flex items-start" data-id="element-2097">
                    <div className="text-burgundy-600 mr-2" data-id="element-2098">•</div>
                    <div data-id="element-2099">
                      Have regular eye tests to ensure your vision meets driving
                      standards.
                    </div>
                  </li>
                  <li className="flex items-start" data-id="element-2100">
                    <div className="text-burgundy-600 mr-2" data-id="element-2101">•</div>
                    <div data-id="element-2102">
                      Take breaks on long journeys - at least 15 minutes every
                      two hours.
                    </div>
                  </li>
                  <li className="flex items-start" data-id="element-2103">
                    <div className="text-burgundy-600 mr-2" data-id="element-2104">•</div>
                    <div data-id="element-2105">
                      Maintain good posture while driving to prevent back
                      problems.
                    </div>
                  </li>
                  <li className="flex items-start" data-id="element-2106">
                    <div className="text-burgundy-600 mr-2" data-id="element-2107">•</div>
                    <div data-id="element-2108">
                      Consider eco-driving techniques to save fuel and reduce
                      environmental impact.
                    </div>
                  </li>
                  <li className="flex items-start" data-id="element-2109">
                    <div className="text-burgundy-600 mr-2" data-id="element-2110">•</div>
                    <div data-id="element-2111">
                      Keep your vehicle well-maintained with regular servicing.
                    </div>
                  </li>
                </ul>
              </div>
            </div>}
        </div>
        <div className="text-center" data-id="element-2112">
          <h2 className="text-2xl font-bold mb-4" data-id="element-2113">
            Need More Specific Advice?
          </h2>
          <p className="text-gray-700 mb-6 max-w-2xl mx-auto" data-id="element-2114">
            Our instructors are always happy to provide personalised tips and
            guidance. Whether you're preparing for your test or looking to
            improve specific driving skills, we're here to help.
          </p>
          <a href="https://www.totaldrive.app/a/enquiry_form.php?17584722727972" target="_blank" rel="noopener noreferrer" className="bg-burgundy-600 hover:bg-burgundy-700 text-white px-6 py-3 rounded-md font-medium inline-block transition-colors" data-id="element-2115">
            Contact Us
          </a>
        </div>
      </div>
    </div>;
};
export default TipsPage;